import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export const MandatoryGears = () => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  return (
    <div className="w-full py-4">
      {/* Clean Image Display without Dark Overlay Wrapper */}
      <div className="w-full flex justify-center">
        <img
          src="/mandatory/mandatory.jpg"
          alt="Mandatory Gears"
          onClick={() => setIsPreviewOpen(true)}
          title="Click to View Full Size"
          className="w-full max-w-4xl h-auto object-contain rounded-xl shadow-sm cursor-pointer transition-transform duration-300 hover:scale-[1.01]"
        />
      </div>

      {/* Full Size Modal Lightbox (z-[9999] to stay above Navbar) */}
      {isPreviewOpen && (
        <div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/85 backdrop-blur-sm p-4 md:p-8"
          onClick={() => setIsPreviewOpen(false)}
        >
          {/* Close Button positioned at Top-Right of Screen so it never covers the image */}
          <button
            onClick={() => setIsPreviewOpen(false)}
            className="fixed top-5 right-5 z-10 bg-gray-900/80 hover:bg-gray-900 text-white rounded-full w-11 h-11 flex items-center justify-center transition-colors shadow-lg border border-white/20"
            title="Close Preview"
          >
            <FontAwesomeIcon icon={faTimes} className="text-xl" />
          </button>

          <div
            className="relative max-w-6xl max-h-[92vh] flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            <img
              src="/mandatory/mandatory.jpg"
              alt="Mandatory Gears Full Preview"
              className="max-w-full max-h-[88vh] object-contain rounded-lg shadow-2xl bg-white"
            />
          </div>
        </div>
      )}
    </div>
  );
};




